export default __webpack_public_path__ + "static/media/جامعة الأميرة نورة.678373ae.png";